import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'

const AccordionItem = ({ children }) => {
  return <div>{children}</div>
}

AccordionItem.propTypes = {
  children: PropTypes.node.isRequired
}

export const getAccordionItemIdentity = (item, index) => {
  if (item?.id !== undefined && item?.id !== null && item?.id !== '') {
    return String(item.id)
  }
  if (item?.key !== undefined && item?.key !== null) {
    return String(item.key)
  }
  return `index-${index}`
}

const Accordion = ({
  contentComponent: ContentComponent,
  headerComponent: HeaderComponent,
  items,
  headerProps,
  contentProps,
  dataTest,
  initialActive = 0,
  activeItemId: controlledActiveItemId,
  onActiveItemIdChange
}) => {
  const isControlled = controlledActiveItemId !== undefined

  const [uncontrolledActiveItemId, setUncontrolledActiveItemId] = useState(() => {
    if (initialActive === null || initialActive === undefined) {
      return null
    }
    if (typeof initialActive === 'number') {
      if (!items[initialActive]) {
        return null
      }
      return getAccordionItemIdentity(items[initialActive], initialActive)
    }
    return String(initialActive)
  })

  const activeItemId = isControlled ? controlledActiveItemId : uncontrolledActiveItemId

  const setActiveItemId = (nextActiveItemId) => {
    if (!isControlled) {
      setUncontrolledActiveItemId(nextActiveItemId)
    }
    if (onActiveItemIdChange) {
      onActiveItemIdChange(nextActiveItemId)
    }
  }

  function toggleAccordion(itemId) {
    if (activeItemId === itemId) {
      return setActiveItemId(null)
    }
    setActiveItemId(itemId)
  }

  function closeAccordion () {
    setActiveItemId(null)
  }
  const accordionItems = useMemo(() => {
    return items.map((item, index) => {
      const itemId = getAccordionItemIdentity(item, index)
      const isOpen = activeItemId === itemId

      return (
        <AccordionItem key={itemId}>
          <>
            <div data-test={dataTest}>
              {/* eslint-disable-next-line no-magic-numbers */}
              <HeaderComponent item={item} lastItem={index + 1 === items.length}
                isOpen={isOpen} {...headerProps} toggleAccordion={() => {
                  toggleAccordion(itemId)
                }} closeAccordion={closeAccordion}/>
            </div>
            {isOpen && <ContentComponent item={item} toggleAccordion={() => {
              toggleAccordion(itemId)
            }} {...contentProps} />}
          </>
        </AccordionItem>
      )
    })
  }, [items, activeItemId, headerProps, contentProps, dataTest])

  return <div>{accordionItems}</div>
}
Accordion.propTypes = {
  contentComponent: PropTypes.elementType.isRequired,
  headerComponent: PropTypes.elementType.isRequired,
  items: PropTypes.array.isRequired,
  headerProps: PropTypes.object,
  contentProps: PropTypes.object,
  dataTest: PropTypes.string,
  initialActive: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  activeItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onActiveItemIdChange: PropTypes.func
}

export default Accordion
